import React from "react";
import NavigationMinimal from "../components/layout/NavigationMinimal";
import { CONTACT_INFO } from "../constants/config";

const Address = () => {
    return (
        <>
            <NavigationMinimal/>
            <div className="sub-hero">
                <span className="sub-hero__eyebrow">So findest du uns</span>
                <h1 className="sub-hero__title">Anfahrt</h1>
                <p className="sub-hero__lead">Das KickerEck befindet sich in der Tremoniaschule in Dortmund. Hier findest du alle Infos zur Anfahrt und zum Parken.</p>
            </div>
            <main className="page-shell page-shell--after-hero address-page">

                <div className="address-card">
                    <h3>{CONTACT_INFO.address.name}</h3>
                    <p>{CONTACT_INFO.address.street}</p>
                    <p>{CONTACT_INFO.address.city}</p>
                </div>

                <div className="address-parking-section">
                    <h2 className="address-section-title">Parken</h2>
                    <div className="address-map-wrap">
                        <img src="img/SkizzeLogo.jpg" className="img-responsive" alt="Skizze Anfahrt und Parken" />
                    </div>
                    <p className="address-parking-text">
                        Das KickerEck befindet sich in der Tremoniaschule (blaue Fläche).
                        Parken könnt Ihr in den rot eingezeichneten Flächen.
                    </p>
                </div>
            </main>
        </>
    );
}

export default Address;
